<template>
  <res-dialog :showDialog="showDialog"
              title=""
              titleClass="resBlue darken-1 white--text"
              iconColor="white"
              :setHeight="height"
              :maxWidth="maxWidth"
              :setWidth="width"
              :cancelButtonOnly="readonly"
              saveButtonColor="resBlue darken-1"
              cancelButtonColor="resBlue darken-1"
              saveButtonText="Update"
              cancelButtonText="Cancel"
              @save="save"
              @cancel="cancel">

    <v-container>
      <v-row>
        <v-col class="light-border no-calc-box" cols="6" v-if="!calculations || !calculations.length">
          <span class="header mb-3 py-1">Calculations</span>
          <br />
          <br />
          <br />
          <span class="block center">No Calculations Exist</span>
        </v-col>
        <v-col cols="6" v-if="calculations && calculations.length > 0">
          <span class="header mb-3 py-1">Calculations</span>
          <template v-for="(calc, index) in calculations">
            <div v-if="index == 0 && calc.recalculated" class="light-border" :key="calc.budgetGLAccountCalculationId + '_recalc'">
              <v-row class="pt-2 py-1">
                <v-col cols="2"><v-btn dark color="resGreen" class="ml-4">Most Recent</v-btn></v-col>
                <v-col cols="5"></v-col>
                <v-col cols="5">
                  {{calc.lastModifiedTimestamp | moment('MM/DD/YYYY hh:mm:ss A')}}
                </v-col>
              </v-row>
              <v-row class="py-2">
                <span class="ml-5 pb-4">
                  {{calc.recalculatedDescription}}
                </span>
              </v-row>
            </div>
            <div v-if="index == 0 || !calculations[0].recalculated" class="light-border" :key="calc.budgetGLAccountCalculationId">
              <v-row class="pt-2 py-1">
                <v-col cols="2"><v-btn v-if="index == 1 || !calculations[0].recalculated" dark :color="index == 0 && !calculations[0].recalculated ? 'resGreen' : 'resBlue'" class="ml-4">{{index == 0 && !calculations[0].recalculated ? 'Most Recent' : 'Previous'}}</v-btn></v-col>
                <v-col cols="5"></v-col>
                <v-col cols="5">
                  {{calc.lastModifiedTimestamp | moment('MM/DD/YYYY hh:mm:ss A')}}
                </v-col>
              </v-row>
              <v-row class="py-2">
                <span class="ml-5 pb-4">
                  {{calc.naturalLanguageDescription}}
                </span>
              </v-row>
            </div>
          </template>
        </v-col>
        <v-divider class="mb-3" vertical></v-divider>
        <v-col cols="5" class="py-2">
          <span class="header py-2">Assumptions</span>
          <v-textarea v-model="newAssumptionStatement"
                      id="assumptionStatementInput"
                      :readonly="readonly"
                      ref="assumptionStatementInput"
                      rows="12"
                      height="225"
                      outlined
                      class="mt-3"
                      counter
                      :rules="[v => (v || '').length <= 250 || 'Assumption statement must be 250 characters or less.']">
          </v-textarea>
        </v-col>
      </v-row>
      <v-divider></v-divider>
    </v-container>
      
  </res-dialog>
</template>

<script>
  import ResDialog from '@/components/base/ResDialog.vue';

  export default {
    props: {
      height: {
        type: Number
      },
      maxWidth: {
        type: Number
      },
      showDialog: {
        type: Boolean
      },
      width: {
        type: Number
      },
      calculations: {
        type: Array,
        default: () => []
      },
      assumptionStatement: {
        type: String,
        default: () => ''
      },
      readonly: {
        type: Boolean,
        default: false
      }
    },
    mixins: [],
    data() {
      return {
        newAssumptionStatement: ''
      }
    },
    components: {
      ResDialog
    },
    methods: {
      async save() {
        this.$emit('save', this.newAssumptionStatement);
      },
      cancel() {
        this.$emit('cancel', true)
      }
    },
    computed: {
    },
    mounted() {
    },
    watch: {
      assumptionStatement() {
        this.newAssumptionStatement = this.assumptionStatement;
      }
    }
  };
</script>

<style scoped lang="scss">
  .header {
    text-align: center;
    display: block;
    font-weight: bold;
  }
  .no-calc-box {
    margin-bottom: 11px !important;
  }
  .light-border {
      border: 1px solid lightgrey;
  }
  .center {
      text-align:center;
  }
</style>
